import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
import {
  faCertificate,
  faFileCircleCheck,
  faHeartCircleCheck,
  faIdBadge,
  faIdCard,
  faPersonCircleCheck,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainContext } from "../App";
import React, { useState, useEffect } from "react";
import apiService from "../api";
import { useLocation } from "react-router-dom";

export const CustomerDriverDetail = (props) => {
  const typeMapping = {
    ehliyet: "Ehliyet",
    psikoTeknik: "Psikoteknik belgesi",
    sabikaKaydi: "Sabıka kaydı",
    saglikRaporu: "Sağlık raporu",
    idCard: "Kimlik",
    isgCertificate: "ISG sertifikası",
  };

  const iconMapping = {
    ehliyet: faIdCard,
    psikoTeknik: faPersonCircleCheck,
    sabikaKaydi: faFileCircleCheck,
    saglikRaporu: faHeartCircleCheck,
    idCard: faIdBadge,
    isgCertificate: faCertificate,
  };

  const { accessToken, setProgress } = React.useContext(MainContext);
  const [driverData, setDriverData] = useState(null);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const driverId = queryParams.get("driverId");
  const driverName = queryParams.get("driverName");
  const sasToken = localStorage.getItem('sasToken');

  useEffect(() => {
    if (!accessToken || !driverId) return;

    setLoading(true);
    apiService.get(`customer/driver/${driverId}/files`, accessToken, setProgress)
      .then(response => {
        if (response.success && response.data) {
          setDriverData(response.data);
        }
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [accessToken, driverId, setProgress]);

  const files = driverData?.files || {};
  const anyDriverDoc = Object.keys(files).some((key) => key in typeMapping && files[key]);

  const generateDriverDocs = () => {
    return Object.keys(files).map((key) => {
      if (key in typeMapping && files[key]) {
        return (
          <Col
            key={key}
            style={{ marginTop: 10 }}
            xs={4}
            onClick={(e) =>
              window.open(
                files[key] + sasToken,
                typeMapping[key],
                "width:550px;height:550px"
              )
            }
          >
            <Card style={{
              cursor: "pointer",
              padding: 3,
              background: "rgba(20, 52, 92, 0.05)",
              border: "2px solid rgba(20, 52, 92, 0.3)",
              borderRadius: "10px",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 30px rgba(20, 52, 92, 0.5)";
              e.currentTarget.style.borderColor = "rgba(20, 52, 92, 0.6)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.borderColor = "rgba(20, 52, 92, 0.3)";
            }}>
              <Card.Body>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: '150px',
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <div>
                    <FontAwesomeIcon
                      color="#5a9bd4"
                      size="2x"
                      icon={iconMapping[key]}
                    ></FontAwesomeIcon>
                  </div>
                  <span style={{
                    fontWeight: 600,
                    fontSize: "18px",
                    color: "#5a9bd4",
                    marginTop: "10px"
                  }}>
                    {typeMapping[key]}
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
      }
      return null;
    });
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%)",
      padding: "20px"
    }}>
      <Container>
        <Card style={{
          marginTop: 10,
          width: "100%",
          background: "#000000",
          border: "2px solid rgba(20, 52, 92, 0.4)",
          borderRadius: "15px",
          boxShadow: "0 8px 40px 0 rgba(20, 52, 92, 0.3)"
        }}>
          <Card.Body>
            <Card.Title style={{
              textAlign: "center",
              color: "#5a9bd4",
              textShadow: "0 0 10px rgba(20, 52, 92, 0.5)",
              fontWeight: "700",
              fontSize: "24px"
            }}>
              Sürücü evrakları - {driverData?.name || driverName || "(-)"}
            </Card.Title>
            {loading ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <Spinner animation="border" style={{ color: "#5a9bd4" }} />
              </div>
            ) : anyDriverDoc ? (
              <Row>{generateDriverDocs()}</Row>
            ) : (
              <Card.Text style={{ color: "#fff", textAlign: "center", marginTop: "20px" }}>
                <u>Sürücüye ait evrak bulunamadı.</u>
              </Card.Text>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};
